module.exports = __webpack_public_path__ + "static/ItemList-879ad730b850c18cc16e5b386fc821b6.png";